/* eslint-disable react/require-default-props */
import { CheckboxGroup, CheckboxGroupProps, Stack, Text } from '@chakra-ui/core';
import React from 'react';
import omit from 'lodash/omit';
import { EmployeePermissionsEnum } from './teamPermission.constant';
import { PermissionGroupType } from './teamPermission.interface';
import TeamPermissionCheckbox from './TeamPermissionCheckbox';

interface PermissionGroupProps extends PermissionGroupType {
  checkboxGroupProps?: CheckboxGroupProps;
  onChange: (value: EmployeePermissionsEnum[]) => void;
  value: EmployeePermissionsEnum[];
}
export default function PermissionGroup({ heading, checkboxGroupProps, permissions, value, onChange }: PermissionGroupProps) {
  return (
    <Stack spacing={3}>
      <Text variant="h5" fontSize="lg" fontWeight="bold">
        {heading}
      </Text>
      <CheckboxGroup colorScheme="green" {...checkboxGroupProps}>
        <Stack spacing={3}>
          {permissions?.map((permission) => (
            <TeamPermissionCheckbox
              key={permission.key}
              {...omit(permission, 'key')}
              value={value.includes(permission.key)}
              onChange={(val) => {
                if (val) {
                  onChange([...value, permission.key]);
                } else {
                  onChange(value.filter((p) => p !== permission.key));
                }
              }}
            />
          ))}
        </Stack>
      </CheckboxGroup>
    </Stack>
  );
}
